
import { computed, defineComponent, PropType } from 'vue';
import { Timestamp } from '@firebase/firestore-types';
import { InputElementTypes } from '@/enums';
import TextInputStyleProvider from '@/components/style-providers/TextInputStyleProvider.vue';
import BaseInput from '@/components/form-controls/base/BaseInput.vue';
import { createTimestamp, createTimestampFromDate } from '@/utils';

export default defineComponent({
  name: 'DateInput',
  emits: ['update:modelValue'],
  components: {
    TextInputStyleProvider,
    BaseInput
  },
  props: {
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: Object as PropType<Timestamp>
    }
  },
  setup(props, { emit }) {
    const date = computed({
      get: () =>
        createTimestamp(props.modelValue?.seconds, props.modelValue?.nanoseconds).toDate().toISOString().split('T')[0],
      set: newValue => {
        const newDate = new Date(newValue);
        const normalizedDate = new Date(newDate.getTime() - newDate.getTimezoneOffset() * -60000);
        emit('update:modelValue', createTimestampFromDate(normalizedDate));
      }
    });

    return {
      date,
      InputElementTypes
    };
  }
});
